import breakpoints, { DEVICE_ICONS, VISIBILITY_STYLES } from '../config/breakpoints'

export default function elementorResponsive(editor) {
  const dm = editor.DeviceManager
  const pn = editor.Panels

  breakpoints.forEach(bp => {
    dm.add({ id: bp.id, name: bp.name, width: bp.width, widthMedia: bp.widthMedia || '' })
  })

  editor.setDevice('Desktop')

  const deviceButtons = breakpoints.map(bp => ({
    id: `eb-device-${bp.id}`,
    className: `fa ${DEVICE_ICONS[bp.id]}`,
    command: `set-device-${bp.id}`,
    active: bp.id === 'desktop',
    togglable: false,
    attributes: { title: bp.name },
  }))

  pn.addPanel({
    id: 'eb-devices',
    el: '.eb-device-bar',
    buttons: deviceButtons,
  })

  breakpoints.forEach(bp => {
    editor.Commands.add(`set-device-${bp.id}`, {
      run(ed) {
        ed.setDevice(bp.name)
      },
      stop() {},
    })
  })

  editor.on('change:device', () => {
    const current = editor.getDevice()
    breakpoints.forEach(bp => {
      const btn = pn.getButton('eb-devices', `eb-device-${bp.id}`)
      if (btn) {
        btn.set('active', bp.name === current)
      }
    })
    updateDeviceLabel(current)
  })

  function updateDeviceLabel(deviceName) {
    const label = document.querySelector('.eb-device-label')
    if (label) {
      const bp = breakpoints.find(b => b.name === deviceName)
      label.textContent = bp ? `${bp.name}${bp.width ? ' (' + bp.width + ')' : ''}` : deviceName
    }
  }

  injectVisibilityStyles(editor)
  registerVisibilityTraits(editor)
}

function injectVisibilityStyles(editor) {
  editor.on('load', () => {
    const frame = editor.Canvas.getFrameEl()
    if (frame && frame.contentDocument) {
      const style = frame.contentDocument.createElement('style')
      style.id = 'eb-visibility-styles'
      style.textContent = VISIBILITY_STYLES
      frame.contentDocument.head.appendChild(style)
    }
  })
}

function registerVisibilityTraits(editor) {
  editor.on('component:selected', (component) => {
    const existing = component.get('traits').models || []
    const hasVisibility = existing.some(t => t.get('name') === 'hide-desktop')
    if (hasVisibility) return

    component.addTrait([
      {
        type: 'checkbox',
        name: 'hide-desktop',
        label: 'Hide on Desktop',
        valueTrue: 'true',
        valueFalse: '',
      },
      {
        type: 'checkbox',
        name: 'hide-tablet',
        label: 'Hide on Tablet',
        valueTrue: 'true',
        valueFalse: '',
      },
      {
        type: 'checkbox',
        name: 'hide-mobile',
        label: 'Hide on Mobile',
        valueTrue: 'true',
        valueFalse: '',
      },
    ])
  })

  editor.on('component:update:traits', (component) => {
    syncVisibilityClasses(component)
  })

  editor.on('trait:value', ({ component }) => {
    syncVisibilityClasses(component)
  })
}

function syncVisibilityClasses(component) {
  if (!component) return
  const attrs = component.getAttributes()
  const classes = component.getClasses()
  const map = {
    'hide-desktop': 'eb-hide-desktop',
    'hide-tablet': 'eb-hide-tablet',
    'hide-mobile': 'eb-hide-mobile',
  }

  Object.keys(map).forEach(attr => {
    const cls = map[attr]
    const isHidden = attrs[attr] === 'true'
    if (isHidden && !classes.includes(cls)) {
      component.addClass(cls)
    } else if (!isHidden && classes.includes(cls)) {
      component.removeClass(cls)
    }
  })
}
